export const emailIsValid = email => {
	const regExp = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
	return regExp.test(email)
}
